import { atom, useAtom } from 'jotai/index';
import { IClaimMultiSignWallet } from 'types';

export const pendingSafesAtom = atom<IClaimMultiSignWallet[]>([]);

export const usePendingSafes = () => {
  const [pendingSafes, setPendingSafes] = useAtom(pendingSafesAtom);

  return {
    pendingSafes,
    setPendingSafes,
  };
};
